import { Form } from 'antd'

import { AntEditableCellContext } from './AntSelectEditableCell'

export const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm()

  return (
    <Form form={form} component={false}>
      <AntEditableCellContext.Provider value={form}>
        <tr {...props} />
      </AntEditableCellContext.Provider>
    </Form>
  )
}
